import { createSlice } from '@reduxjs/toolkit'
import remove from './reducers/removeBoxLabel'
import changeName from './reducers/changeLabelName'
import toggleHideBoxLabel from './reducers/toggleHideBoxLabel'

export const slice = createSlice({
  name: 'boxlabels',
  initialState: {
    labels: {},
    labelsCount: 0,
  },
  reducers: {
    addBoxLabel: (state, action) => {
      const label = action.payload
      const labelId = label.id
    
      if (labelId !== undefined) {
        // Instead of an object, we could use a Map, so we make sure we only add each box once.
        state.labels[labelId] = {
          ...label
        }
        state.labelsCount = state.labelsCount + 1
      } else {
        throw new Error('Cannot create label with id: undefined')
      }
    },
    changeLabelIndex: (state, action) => {
      const {
        labelId,
        index
      } = action.payload
    
      if (state.labels[labelId] !== undefined) {
        state.labels[labelId].sortindex = index
        const targetIndex = index
        const currentIndex = state.labels[labelId].sortindex
        const isMovingUp = targetIndex > currentIndex
      
        const labelsToBeModified = Object.values(state.labels).filter((label) => label.sortindex === targetIndex)
      
        for (const label of labelsToBeModified) {
          let newLabelSortIndex = label.sortindex + (isMovingUp ? -1 : 1)
          newLabelSortIndex = isMovingUp
            ? Math.min(newLabelSortIndex, Object.values(state.labels).length - 1)
            : Math.max(0, newLabelSortIndex)
      
          state.labels[label.id].sortindex = newLabelSortIndex
        }
      } else {
        throw new Error('Cannot create box with id: undefined')
      }
    },
    removeLabel: remove,
    changeLabelName: changeName,
    toggleLabelVisibility: toggleHideBoxLabel,
  },
})

export const { addBoxLabel, removeLabel, changeLabelName, changeLabelIndex, toggleLabelVisibility } = slice.actions

export default slice.reducer
